export function polarPoint(
  centerX: number,
  centerY: number,
  radius: number,
  degrees: number
): [number, number] {
  const radians = ((degrees - 90) * Math.PI) / 180
  return [
    centerX + radius * Math.cos(radians),
    centerY + radius * Math.sin(radians),
  ]
}

export function arcPath(
  centerX: number,
  centerY: number,
  radius: number,
  fromDegrees: number,
  toDegrees: number
) {
  const start = polarPoint(centerX, centerY, radius, fromDegrees)
  const end = polarPoint(centerX, centerY, radius, toDegrees)
  const largeArc =
    Math.abs(toDegrees - fromDegrees) > 180 ? 1 : 0
  return `M ${start[0]} ${start[1]} A ${radius} ${radius} 0 ${largeArc} 1 ${end[0]} ${end[1]}`
}
